import { useLocation } from "react-router-dom";
import HomeLayout from "./main/homelayout";
import UserLayout from "./user/layout";
import NUserLayout from "./user/new-layout";
import NHomeLayout from "./main/xhomelayout";

export default function MainLayout() {
  const { pathname } = useLocation();
  // console.log(pathname);
  return <>{pathname === `/` ? <NHomeLayout /> : <NUserLayout />}</>;
}
